export default __webpack_public_path__ + "static/media/คืนค่าคอม-1-ทุกยอดเทิร์น v2.13a5300f.png";